import Page from '../components/configs/Page';

import {
  //Stack,
  //Card, 
  //CardHeader,
  //Box, 
  Grid, 
  Container,
  //Typography
} from '@mui/material';


  import {
    InfoUtente,
    SessoesUtente,
    AtividadeUtente,
    DicasUtente,
  } from '../components/utente';

// ----------------------------------------------------------------------


export default function PerfilUtente() {
  return (
    <Page title="INPACT | Utente">
      <Container maxWidth="xl">

            <Grid container spacing={1}>
                {/* Info utente na lateral esquerda... 12, 6, 12,  */}
                <Grid item xs={12} md={12} lg={12}>
                    <InfoUtente />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <SessoesUtente />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <AtividadeUtente />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <DicasUtente />
                </Grid>
            </Grid>
        </Container>
    </Page>
  );
}
